import React from "react"
import autobind from "class-autobind"
import { IScheduleDocument, ISchedulePatternTemplate, IDate } from "../../../../../models"
import _ from "lodash"
import * as hierarchyHelper from "../../../../../helpers/hierarchyHelper"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import * as timeHelper from "../../../../../helpers/timeHelper"
import ToolTip from "react-portal-tooltip"
import moment from "moment"
import AppStateStore from "../../../../../stores/AppStateStore"
import * as colorHelper from "../../../../../helpers/colorHelper"
import AccountStore from "../../../../../stores/AccountStore"
import { Card, CardHeader, CardText, Paper } from "material-ui"
import ScheduleResourcePlannerItemBudgetSummary from "./ScheduleResourcePlannerItemBudgetSummary"
import DonutChart from "../../../../common/donutChart/DonutChart"
import * as api from "../../../../../api"

interface IProps {
    selectedDay: IDate
    schedule: IScheduleDocument
    handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
    handleUnAssignEmployee(unAssignPatternTemplate: ISchedulePatternTemplate): void
    reload(): void
}

interface IState {
    toolTip: string
    userTypeToolTip: string
    expandBudgetSummary: boolean
}

export default class ScheduleResourcePlannerItem extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            toolTip: undefined,
            userTypeToolTip: undefined,
            expandBudgetSummary: false
        }
        autobind(this)
    }

    getEmployeeTypeSummaryBreakdown() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        let redMarginColor = undefined
        if (this.props.schedule.Summary && this.props.schedule.Summary.BudgetSummary) {
            if (this.props.schedule.Summary.BudgetSummary.Margin < 20) {
                redMarginColor = "#f44336"
            }
        }

        if (this.props.schedule.Summary && this.props.schedule.Summary.BudgetSummary && AccountStore.getCRMEnabled()) {
            return (
                <Card
                    expanded={this.state.expandBudgetSummary}
                    onExpandChange={expandBudgetSummary => this.setState({ expandBudgetSummary })}
                    style={{ marginTop: 5, marginBottom: 5 }}
                >
                    <CardHeader
                        title={"Staff Summary"}
                        actAsExpander
                        showExpandableButton
                        titleStyle={{ fontSize: 14, display: "initial" }}
                    />
                    <CardText expandable={true}>
                        <div style={{ display: "grid", fontSize: 12 }}>
                            {this.getStaffingInfoLabelColumn("Core Staff", this.props.schedule.Summary.FilledByCore)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByCore)}
                            {this.getStaffingInfoLabelColumn("Float Staff", this.props.schedule.Summary.FilledByFloat)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByFloat)}
                            {this.getStaffingInfoLabelColumn("Per Diem Staff", this.props.schedule.Summary.FilledByPerDiem)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByPerDiem)}
                            {this.getStaffingInfoLabelColumn("Agency Staff", this.props.schedule.Summary.FilledByAgency)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByAgency)}

                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10, marginTop: 15 }}><b>Pay:</b></div><div style={{ gridRow: "auto", gridColumn: 2, marginTop: 15 }}>{formatter.format(this.props.schedule.Summary.BudgetSummary.Pay)}</div>
                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Bill:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(this.props.schedule.Summary.BudgetSummary.Bill)}</div>
                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10, color: redMarginColor }}><b>Margin:</b></div><div style={{ gridRow: "auto", gridColumn: 2, color: redMarginColor }}>{this.props.schedule.Summary.BudgetSummary.Margin}%</div>
                        </div>
                    </CardText>
                </Card>
            )
        }
    }

    getStaffingInfoLabelColumn(label, number) {
        if (number && number > 0) {
            return <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>{label}: </b></div>
        }
    }

    getStaffingInfoValueColumn(number) {
        if (number && number > 0) {
            return <div style={{ gridRow: "auto", gridColumn: 2 }}>{Math.round(100 * number)}%</div>
        }
    }

    handleUpdateDailyBudget(budgetDay, dayIndex) {
        const schedule = _.cloneDeep(this.props.schedule)
        if (!schedule.Budget.Days) {
            schedule.Budget = {
                Days: []
            }
            schedule.Budget.Days.push(budgetDay)
        } else {
            schedule.Budget.Days[dayIndex] = budgetDay
        }

        api.updateSchedule(schedule).then(res => {
            AppStateStore.setProgressSnackbarContent("Schedule Updated")
            this.props.reload()
        })
    }

    render() {
        const dailyBudget = scheduleHelper.getDailyBudgetByDate(this.props.selectedDay, this.props.schedule.Budget ? this.props.schedule.Budget.Days : [])
        const patternTemplatesForDay = scheduleHelper.getPatternTemplatesByDate(this.props.selectedDay, this.props.schedule.Schedules)
            .filter((pt) => !pt.Deleted)
            .sort((a, b) => {
                if (a.AssignedUserId && b.AssignedUserId) return 0
                if (a.AssignedUserId < b.AssignedUserId) return -1
                if (a.AssignedUserId > b.AssignedUserId) return 1
            }).sort((a, b) => {
                if (a.AssignedUserName === b.AssignedUserName) return 0
                if (a.AssignedUserName < b.AssignedUserName) return -1
                if (a.AssignedUserName > b.AssignedUserName) return 1
            }).sort((a, b) => {
                if (!a.ShiftTemplates[0].Position && !b.ShiftTemplates[0].Position) return 0
                if (!a.ShiftTemplates[0].Position && b.ShiftTemplates[0].Position) return -1
                if (a.ShiftTemplates[0].Position && !b.ShiftTemplates[0].Position) return 1
                if (a.ShiftTemplates[0].Position.Name === b.ShiftTemplates[0].Position.Name) return 0
                if (a.ShiftTemplates[0].Position.Name < b.ShiftTemplates[0].Position.Name) return -1
                if (a.ShiftTemplates[0].Position.Name > b.ShiftTemplates[0].Position.Name) return 1
            })

        const rowHeight = undefined
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        })

        let censusValue = dailyBudget ? scheduleHelper.getSingleBudgetVolumeUnitValue(dailyBudget.BudgetPositions) : 0
        let showCensus = dailyBudget ? scheduleHelper.isSingleBudgetVolumeUnit(dailyBudget.BudgetPositions) : false

        if (patternTemplatesForDay.length == 0) {
            return (<span />);
        }

        return (
            <Paper style={{ margin: 10 }}>
                <div style={{ padding: 10, position: "relative" }} id="ScheduleViewPlace">
                    <div style={{ display: "grid", gridTemplateColumns: "auto min-content" }}>
                        <div style={{ gridColumn: 1 }}>
                            <div style={{ fontSize: 10 }}>
                                {hierarchyHelper.getFullyQualifiedLevelNameById(this.props.schedule.HierarchyId)}
                            </div>
                            <div style={{ fontSize: 16, fontWeight: 500 }}>
                                {this.props.schedule.Name}
                            </div>
                            <div style={{ fontSize: 10 }}>
                                <b>
                                    <span>{moment(this.props.selectedDay).format("dddd")} the {moment(this.props.selectedDay).format("Do")}</span>
                                </b>
                                {moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).format("MM/DD/YY")} - {moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.EndDate)).format("MM/DD/YY")}
                            </div>
                        </div>
                        <div style={{ gridColumn: 2 }}>
                            {patternTemplatesForDay.length > 0 &&
                                <DonutChart
                                    value={Math.round(patternTemplatesForDay.filter(i => i.AssignedUserId ? true : false).length * 100 / patternTemplatesForDay.length)}
                                    valueLabelYPosition={24}
                                    strokeWidth={4}
                                    size={40}
                                    textValStyle={{ fontSize: 12 }}
                                    percentStyle={{ fontSize: 12 }}
                                    textLabelStyle={{ display: "none" }}
                                    spaceBetweenValAndLabel={0}
                                />
                            }
                        </div>
                    </div>
                    {this.getEmployeeTypeSummaryBreakdown()}
                    {patternTemplatesForDay && patternTemplatesForDay.length > 0 &&
                        <div>
                            {dailyBudget &&
                                <div>
                                    {showCensus &&
                                        <h4>Census: {censusValue}</h4>
                                    }
                                    {AccountStore.getEnableDailyScheduleBudget() && dailyBudget &&
                                        <ScheduleResourcePlannerItemBudgetSummary
                                            scheduleBudgetDay={dailyBudget}
                                            handleUpdateDailyBudget={this.handleUpdateDailyBudget}
                                        />
                                    }
                                </div>
                            }
                            <table cellSpacing={0} cellPadding={5}>
                                {patternTemplatesForDay.map((row, index) => {
                                    let positionColor = colorHelper.getBudgetPositionColor(row, dailyBudget)
                                    var rowId = row && row.ShiftTemplates && row.ShiftTemplates.length > 0 ? row.ShiftTemplates[0].Id : null

                                    const userType = (row && AccountStore.getCRMEnabled() && (row.FloatUser || row.PerDiemUser || row.AgencyUser)) ?
                                        <span style={{ fontSize: 15 }}
                                            onMouseEnter={() => this.setState({ userTypeToolTip: rowId })}
                                            onMouseLeave={() => this.setState({ userTypeToolTip: undefined })}
                                            id={"schedule-row-employee-type-" + rowId}
                                        >
                                            <i
                                                className={colorHelper.getEmployeeTypeStyleData(row.FloatUser, row.PerDiemUser, row.AgencyUser).className}
                                                style={{ color: colorHelper.getEmployeeTypeStyleData(row.FloatUser, row.PerDiemUser, row.AgencyUser).color }}
                                            />
                                            <ToolTip
                                                active={rowId === this.state.userTypeToolTip}
                                                position="top"
                                                arrow="left"
                                                parent={"#schedule-row-employee-type-" + rowId}
                                                key={"#schedule-row-employee-type-" + rowId}
                                                group={"#schedule-row-employee-type-" + rowId}
                                            >
                                                {!row.FloatUser && !row.PerDiemUser && !row.AgencyUser && <span>Core Staff</span>}
                                                {row.FloatUser && <span>Float Staff</span>}
                                                {row.PerDiemUser && <span>Per Diem Staff</span>}
                                                {row.AgencyUser && <span>Agency Staff</span>}
                                            </ToolTip>
                                        </span> : undefined

                                    return (
                                        <tr key={index}>
                                            <td
                                                style={{
                                                    gridRow: index,
                                                    height: rowHeight,
                                                    backgroundColor: scheduleHelper.getTransparentBackgroundColor(positionColor),
                                                    paddingLeft: 10,
                                                    borderTopLeftRadius: 5,
                                                    borderBottomLeftRadius: 5,
                                                }}
                                            >
                                                {row.BudgetSummary &&
                                                    <i
                                                        className="fa-solid fa-circle-dollar"
                                                        onMouseEnter={() => this.setState({ toolTip: row.Id })}
                                                        onMouseLeave={() => this.setState({ toolTip: undefined })}
                                                        style={{ color: scheduleHelper.getMarginColor(row), marginRight: 10 }}
                                                    />
                                                }
                                                {row.BudgetSummary &&
                                                    <ToolTip
                                                        active={row.Id === this.state.toolTip}
                                                        position="right"
                                                        arrow="left"
                                                        parent={"#schedule-row-item-" + row.Id}
                                                        key={"#schedule-row-item-" + row.Id}
                                                        group={"#schedule-row-item-" + row.Id}
                                                    >
                                                        <div style={{ display: "grid", padding: 15 }}>
                                                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Pay:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Pay)}</div>
                                                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Bill:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Bill)}</div>
                                                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Burden:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Burden)}</div>
                                                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Net:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Net)}</div>
                                                            <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10, color: scheduleHelper.getMarginColor(row) }}><b>Margin:</b></div><div style={{ gridRow: "auto", gridColumn: 2, color: scheduleHelper.getMarginColor(row) }}>{row.BudgetSummary.Margin}%</div>
                                                        </div>
                                                    </ToolTip>
                                                }
                                                {userType}
                                            </td>
                                            <td
                                                style={{
                                                    gridRow: index,
                                                    height: rowHeight,
                                                    color: positionColor,
                                                    backgroundColor: scheduleHelper.getTransparentBackgroundColor(positionColor),
                                                }}
                                                id={"schedule-row-item-" + row.Id}
                                            >
                                                {row.ShiftTemplates[0].Position ? row.ShiftTemplates[0].Position.Name : ""}
                                            </td>
                                            <td
                                                className="TextOverflow"
                                                style={{
                                                    gridRow: index,
                                                    height: rowHeight,
                                                    color: positionColor,
                                                    background: scheduleHelper.getTransparentBackgroundColorFade(positionColor, "#ffffff"),
                                                    maxWidth: 100
                                                }}
                                                title={row.AssignedUserName}
                                            >
                                                <span style={{ display: "block" }}>{row.AssignedUserName}</span>
                                                {row.AssignedUserExternalId &&
                                                    <span style={{ display: "block", color: "rgb(158, 158, 158)", fontSize: 10, marginTop: -5 }}>
                                                        Emp #: {row.AssignedUserExternalId}
                                                    </span>
                                                }
                                            </td>
                                            <td
                                                style={{
                                                    gridRow: index,
                                                    height: rowHeight
                                                }}
                                            >
                                                {!row.AssignedUserId &&
                                                    <i
                                                        className="fa fa-plus-circle"
                                                        style={{ fontSize: 14, cursor: "pointer" }}
                                                        onClick={() => this.props.handleAssignEmployee(row)}
                                                    />
                                                }
                                                {row.AssignedUserId &&
                                                    <i
                                                        className="fa fa-x"
                                                        style={{ fontSize: 14, cursor: "pointer" }}
                                                        onClick={() => this.props.handleUnAssignEmployee(row)}
                                                    />
                                                }
                                            </td>
                                            <td
                                                style={{
                                                    gridRow: index,
                                                    height: rowHeight
                                                }}
                                            >
                                                {moment(scheduleHelper.getTimeFromSimpleTime(row.ShiftTemplates[0].StartTime)).format("h:mma")}
                                            </td>
                                            <td
                                                style={{
                                                    gridRow: index,
                                                    height: rowHeight
                                                }}
                                            >
                                                {moment(scheduleHelper.getTimeFromSimpleTime(row.ShiftTemplates[0].EndTime)).format("h:mma")}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </table>
                        </div>
                    }
                    {!patternTemplatesForDay || patternTemplatesForDay.length == 0 &&
                        <div style={{ textAlign: "center", padding: 30 }}><b>No Shifts</b></div>
                    }
                </div>
            </Paper>
        )
    }
}